import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { PublicAppListing, usePublicAppListingByIdQuery } from '../../../types/generated';
import { AppDetailsView } from './AppDetailsView';
import { CircularProgress } from '@material-ui/core';

export const AppDetails = () => {
    const [error, setError] = useState(false);
    const { listingId } = useParams<{ listingId: string }>();

    const { loading, data } = usePublicAppListingByIdQuery({
        variables: {
            id: listingId,
        },
    });

    useEffect(() => {
        if (!loading && !data) {
            setError(true);
        } else {
            setError(false);
        }
    }, [loading, data]);

    if (loading) {
        return <CircularProgress />;
    }

    if (error || !data) {
        throw new Error('Sorry we could not find the page you were looking for.');
    }
    const listing: PublicAppListing | any = data.publicAppListing;
    return <AppDetailsView listing={listing} />;
};
